// 2_components/search_raventic_results_setup_new.js
// Vendor Raventic search-RESULTS integration (test eshop only), v4 SDK: defines
// window.RaventicSearchResultsConfig and runs Raventic's loader snippet, which
// injects the v4 results SDK. The minified loader IIFE is vendor code, left untouched.

export function init() {
	/* if (!document.body.classList.contains("is-test-eshop") && !document.body.classList.contains("sk")) return; */
	if (!location.href.includes(window.NAT.raventic[window.NAT.lang].resultsUrlMatch)) return;

	window.RaventicSearchResultsConfig = {
		elementSelector: "#content",
		config: {
			locale: window.NAT.raventic[window.NAT.lang].locale,
			apiKey: window.NAT.raventic[window.NAT.lang].apiKey,

			currency: window.NAT.raventic[window.NAT.lang].currency,
			priceDecimals: window.NAT.raventic[window.NAT.lang].priceDecimals,

			noResultsFoundMessage: window.NAT.translations("raventicNoResults"),

			queryParameterName: "string",

			pageSize: 20,

			title: window.NAT.translations("raventicResultsTitle"),
			noQueryTitle: window.NAT.translations("raventicNoQueryTitle"),

			categoriesTitle: window.NAT.translations("raventicCategoriesTitle"),
			manufacturersTitle: window.NAT.translations("raventicManufacturersTitle"),
			/* showManufacturers: true, */
			showManufacturers: false,
			analyticsEventsTarget: "dataLayer",

			priceTitle: window.NAT.translations("raventicPriceTitle"),

			disableDefaultStyles: true,

			filtersTitle: window.NAT.translations("raventicFiltersTitle"),
			filterButtonTitle: window.NAT.translations("raventicFilterButton"),
			clearAllFiltersTitle: window.NAT.translations("raventicClearAllFilters"),
			buttonTypeParameterName: "button-type",
			buttonLabelParameterName: "button-text",
			buttonStyleParameterName: "button-style",

			priceParameterName: "_price",
			salePriceParameterName: "_sale-price",

			individualParameters: [
				{
					parameterName: "SHORT_DESCRIPTION",
					title: window.NAT.translations("raventicParamDescription"),
				},
				{
					parameterName: "RATING_AVG",
					title: window.NAT.translations("raventicParamRating"),
				},
				{
					parameterName: "RATING_TOTAL",
					title: window.NAT.translations("raventicParamReviewCount"),
				},
				{
					parameterName: "IMGURL_ALTERNATIVE",
					title: window.NAT.translations("raventicParamAltImage"),
				},
				{
					parameterName: "STOCK_AMOUNT",
					title: window.NAT.translations("raventicParamStock"),
				},
			],

			promoContent: [
				{
					title: window.NAT.translations("raventicCategoriesTitle"), // titulek bloku
					identifier: "categories_feed",
					maxCount: 6,
				},
				/* 		{
					title: window.NAT.translations("raventicArticlesTitle"), // titulek tabu pro výsledky článků
					identifier: "articles",
					maxCount: 4, // maximální počet výsledků na stránku
				}, */
			],

			/* 		additionalContent: [
				{
					title: "Články", // titulek tabu pro výsledky článků
					identifier: "articles",
					maxCount: 10, // maximální počet výsledků na stránku
				},
			], */

			customStyles: ``,
			customPageStyles: ``,

			desktopMode: "top",

			defaultButtonLabel: window.NAT.translations("raventicAddToCart"),
			cartConfig: {
				type: "NoActionCart",
			},
		},
		onProductClick: handleProductClick,
		resultHandler: handleResult,
		runABTest: false,
	};

	// Vendor Raventic v4 loader — reads window.RaventicSearchResultsConfig and injects
	// .../semsearch/v4/results.min.js. Left exactly as provided by Raventic.
	!(function () {
		const e = window.RaventicSearchResultsConfig;
		if (!e)
			return void console.error(
				"RaventicSearchResultsConfig is not defined. Please set window.RaventicSearchResultsConfig before loading this script.",
			);
		const {
			elementSelector: t,
			config: n,
			onOpen: a,
			onProductClick: i,
			errorHandler: r,
			resultHandler: o,
			eventPusher: c,
			runABTest: s,
		} = e;
		if (s) {
			const e = "search_dropdown",
				t = "RaventicSearchIntegrationTest";
			void 0 === window.dataLayer && (window.dataLayer = []);
			const n = "_rvn_ab",
				a = "0",
				i = "1";
			let r = null;
			try {
				r = window.localStorage.getItem(n);
			} catch {
				r = document.cookie
					.split("; ")
					.find((e) => e.startsWith(n + "="))
					?.split("=")[1];
			}
			variant = r === a || r === i ? r : Math.random() < 0.5 ? a : i;
			try {
				window.localStorage.setItem(n, variant);
			} catch {}
			if (
				((document.cookie = `${n}=${variant}; domain=${location.hostname}; path=/; max-age=${365 * 86400}; sameSite=Lax`),
				t &&
					window.dataLayer.push({ event: t, raventic: { search: {}, raventic_variant: variant, raventic_widget: e } }),
				variant === a)
			)
				return;
		}
		let d = !1;
		window.raventicResultsReady = function (e) {
			d || ((d = !0), e(t, n, a, i, r, o, c));
		};
		const l = document.createElement("script");
		((l.src = "https://sdk.rvndn.com/semsearch/v4/results.min.js"), document.head.appendChild(l));
	})();

	initRaventicPriceSlider();
}

function handleProductClick(product, instanceId, action) {
	if (action === "add-to-cart") {
		shoptet.cartShared.addToCart({ productCode: product.id });
	}
}

function handleResult(result, error, reference, instanceId) {
	if (error) {
		console.error("Raventic API error:", error);
		return;
	}
	window.raventicResult = result;
	document.dispatchEvent(new CustomEvent("RAVENTIC SEARCH RESULTS LOADED"));
}

function initRaventicPriceSlider() {
	let priceSliderTimer = null;

	function scheduleRaventicPriceSlider() {
		if (priceSliderTimer) return;
		priceSliderTimer = setTimeout(function () {
			priceSliderTimer = null;
			mountRaventicPriceSliders();
		}, 0);
	}

	function parsePrice(value) {
		if (value == null) return null;
		const normalized = String(value).trim().replace(/\s/g, "").replace(",", ".");
		if (!normalized) return null;
		const number = Number.parseFloat(normalized);
		return Number.isNaN(number) ? null : number;
	}

	function setInputValue(input, value) {
		const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value").set;
		setter.call(input, value);
	}

	function commitPriceInput(input) {
		input.dispatchEvent(new FocusEvent("focusout", { bubbles: true }));
	}

	function mountRaventicPriceSliders() {
		document.querySelectorAll(".raventic-search-results-filters-filter-price").forEach(function (filter) {
			const selector = filter.querySelector(".raventic-search-results-filters-filter-price-selector");
			if (!selector) return;
			const inputs = selector.querySelectorAll("input");
			if (inputs.length < 2) return;
			const minInput = inputs[0];
			const maxInput = inputs[1];
			const boundMin = parsePrice(minInput.getAttribute("placeholder"));
			const boundMax = parsePrice(maxInput.getAttribute("placeholder"));
			if (boundMin == null || boundMax == null || boundMax <= boundMin) return;

			let slider = filter.querySelector(".raventic-price-slider");
			if (!slider) {
				slider = document.createElement("div");
				slider.className = "raventic-price-slider";
				slider.innerHTML =
					'<div class="raventic-price-slider__track">' +
					'<div class="raventic-price-slider__range"></div>' +
					'<span class="raventic-price-slider__handle raventic-price-slider__handle--min" role="slider" tabindex="0"></span>' +
					'<span class="raventic-price-slider__handle raventic-price-slider__handle--max" role="slider" tabindex="0"></span>' +
					"</div>";
				selector.before(slider);
				bindPriceSlider(slider, minInput, maxInput);
			}

			const currentMin = parsePrice(minInput.value) ?? boundMin;
			const currentMax = parsePrice(maxInput.value) ?? boundMax;
			positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
		});
	}

	function positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax) {
		const span = boundMax - boundMin;
		const minRatio = span ? (currentMin - boundMin) / span : 0;
		const maxRatio = span ? (currentMax - boundMin) / span : 1;
		const minHandle = slider.querySelector(".raventic-price-slider__handle--min");
		const maxHandle = slider.querySelector(".raventic-price-slider__handle--max");
		const range = slider.querySelector(".raventic-price-slider__range");
		minHandle.style.left = minRatio * 100 + "%";
		maxHandle.style.left = maxRatio * 100 + "%";
		range.style.left = minRatio * 100 + "%";
		range.style.width = (maxRatio - minRatio) * 100 + "%";
		minHandle.setAttribute("aria-valuemin", String(boundMin));
		minHandle.setAttribute("aria-valuemax", String(boundMax));
		minHandle.setAttribute("aria-valuenow", String(currentMin));
		maxHandle.setAttribute("aria-valuemin", String(boundMin));
		maxHandle.setAttribute("aria-valuemax", String(boundMax));
		maxHandle.setAttribute("aria-valuenow", String(currentMax));
	}

	function bindPriceSlider(slider, minInput, maxInput) {
		const track = slider.querySelector(".raventic-price-slider__track");
		slider.querySelectorAll(".raventic-price-slider__handle").forEach(function (handle) {
			const side = handle.classList.contains("raventic-price-slider__handle--min") ? "min" : "max";
			handle.addEventListener("pointerdown", function (event) {
				if (event.button != null && event.button !== 0) return;
				event.preventDefault();
				const boundMin = parsePrice(minInput.getAttribute("placeholder"));
				const boundMax = parsePrice(maxInput.getAttribute("placeholder"));
				if (boundMin == null || boundMax == null) return;
				const input = side === "min" ? minInput : maxInput;
				const drag = {
					side: side,
					input: input,
					boundMin: boundMin,
					boundMax: boundMax,
					startRaw: input.value,
					pointerId: event.pointerId,
				};
				handle.setPointerCapture(event.pointerId);

				function valueFromEvent(pointerEvent) {
					const rect = track.getBoundingClientRect();
					const ratio = rect.width ? (pointerEvent.clientX - rect.left) / rect.width : 0;
					const clamped = Math.min(1, Math.max(0, ratio));
					let next = Math.round(boundMin + clamped * (boundMax - boundMin));
					const other = side === "min" ? parsePrice(maxInput.value) ?? boundMax : parsePrice(minInput.value) ?? boundMin;
					if (side === "min") next = Math.min(next, other);
					else next = Math.max(next, other);
					return next;
				}

				function onMove(pointerEvent) {
					if (pointerEvent.pointerId !== drag.pointerId) return;
					const next = valueFromEvent(pointerEvent);
					setInputValue(drag.input, String(next));
					const currentMin = side === "min" ? next : parsePrice(minInput.value) ?? boundMin;
					const currentMax = side === "max" ? next : parsePrice(maxInput.value) ?? boundMax;
					positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
				}

				function onUp(pointerEvent) {
					if (pointerEvent.pointerId !== drag.pointerId) return;
					handle.removeEventListener("pointermove", onMove);
					handle.removeEventListener("pointerup", onUp);
					handle.removeEventListener("pointercancel", onUp);
					const next = valueFromEvent(pointerEvent);
					const atBound = side === "min" ? next <= boundMin : next >= boundMax;
					const nextValue = atBound ? "" : String(next);
					if (nextValue === drag.startRaw) {
						setInputValue(drag.input, drag.startRaw);
						const currentMin = parsePrice(minInput.value) ?? boundMin;
						const currentMax = parsePrice(maxInput.value) ?? boundMax;
						positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
						return;
					}
					setInputValue(drag.input, nextValue);
					commitPriceInput(drag.input);
				}

				handle.addEventListener("pointermove", onMove);
				handle.addEventListener("pointerup", onUp);
				handle.addEventListener("pointercancel", onUp);
			});

			handle.addEventListener("keydown", function (event) {
				if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
				event.preventDefault();
				const boundMin = parsePrice(minInput.getAttribute("placeholder"));
				const boundMax = parsePrice(maxInput.getAttribute("placeholder"));
				if (boundMin == null || boundMax == null) return;
				const input = side === "min" ? minInput : maxInput;
				const previous = input.value;
				const step = event.shiftKey ? 10 : 1;
				const direction = event.key === "ArrowRight" ? 1 : -1;
				let next = Math.round((parsePrice(input.value) ?? (side === "min" ? boundMin : boundMax)) + step * direction);
				const other = side === "min" ? parsePrice(maxInput.value) ?? boundMax : parsePrice(minInput.value) ?? boundMin;
				if (side === "min") next = Math.max(boundMin, Math.min(next, other));
				else next = Math.min(boundMax, Math.max(next, other));
				const atBound = side === "min" ? next <= boundMin : next >= boundMax;
				const nextValue = atBound ? "" : String(next);
				if (nextValue === previous) return;
				setInputValue(input, nextValue);
				const currentMin = parsePrice(minInput.value) ?? boundMin;
				const currentMax = parsePrice(maxInput.value) ?? boundMax;
				positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
				commitPriceInput(input);
			});
		});
	}

	document.addEventListener("RAVENTIC SEARCH RESULTS LOADED", scheduleRaventicPriceSlider);
	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", scheduleRaventicPriceSlider);
	document.addEventListener(
		"click",
		function (event) {
			if (event.target.closest(".raventic-search-results-filters-filter-price")) {
				scheduleRaventicPriceSlider();
			}
		},
		true,
	);

	const root = document.querySelector("#content") || document.body;
	const observer = new MutationObserver(function () {
		const needsMount = Array.from(document.querySelectorAll(".raventic-search-results-filters-filter-price")).some(
			function (filter) {
				return (
					filter.querySelector(".raventic-search-results-filters-filter-price-selector") &&
					!filter.querySelector(".raventic-price-slider")
				);
			},
		);
		if (needsMount) scheduleRaventicPriceSlider();
	});
	observer.observe(root, { childList: true, subtree: true });
	scheduleRaventicPriceSlider();
}
